import { IProductBase } from '../../models/products';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateProductProps {
  name: string;
  isActive: boolean;
  costCenter: string;
  productCode: string;
  productType: string;
  productNature: string;
  description?: string;
  invoiceType: 'NF' | 'ND';
}

export type INewProduct = IProductBase;

export const createProductsService = async ({
  name,
  isActive,
  costCenter,
  productCode,
  productType,
  productNature,
  description,
  invoiceType,
}: ICreateProductProps): Promise<INewProduct> => {
  const { data } = await jhsfBookingsApi.post<INewProduct>('/products', {
    name,
    isActive,
    costCenter,
    productCode,
    productType,
    productNature,
    description,
    invoiceType,
  });

  return data;
};
